<template>
  <b-row>
    <b-col cols="12" class="mt-3" xl v-for="e in days" :key="e.isoWeekday">
      <b-row
        class="flex-xl-column h-100 justify-content-center justify-content-xl-start"
      >
        <b-col cols="12" xl="auto">
          <h4 class="d-inline-block mx-2">{{ e.label }}</h4>
          <h6 class="pb-1 pb-xl-2 d-inline-block d-xl-block">{{ e.date }}</h6>
        </b-col>
        <b-col
          cols="6"
          sm="3"
          xl="auto"
          class="px-2 my-1"
          v-for="appointment in e.appointments"
          :key="appointment.id"
        >
          <div class="slot" v-on:click="$emit('update', appointment)">
            {{ appointment.start.format("H[h]mm") }} -
            {{ appointment.end.format("H[h]mm") }}
          </div>
        </b-col>
        <b-col
          cols="6"
          sm="3"
          xl="auto"
          class="px-2 my-1"
          v-if="e.appointments === false"
        >
          <b-skeleton animation="wave" width="100%"></b-skeleton>
        </b-col>
        <b-col
          cols="6"
          sm="3"
          xl="auto"
          class="px-2 my-1"
          v-if="e.appointments === false"
        >
          <b-skeleton animation="wave" width="100%"></b-skeleton>
        </b-col>
        <b-col v-if="!e.appointments.length && e.appointments !== false">
          <div class="slot no-items bg-light text-dark h-100 d-flex">
            <p class="my-auto mx-auto">Aucune disponibilité pour ce jour</p>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import { getAllActivitesByActionAndLocationAsync } from "../api/activityApi";

export default {
  name: "Calendar",

  props: {
    date: Date,
    distancial: Boolean,
    action: String,
    office: Object
  },

  data() {
    return {
      days: [
        { isoWeekday: 1, label: "Lundi", date: null, appointments: [] },
        { isoWeekday: 2, label: "Mardi", date: null, appointments: [] },
        { isoWeekday: 3, label: "Mercredi", date: null, appointments: [] },
        { isoWeekday: 4, label: "Jeudi", date: null, appointments: [] },
        { isoWeekday: 5, label: "Vendredi", date: null, appointments: [] },
        { isoWeekday: 6, label: "Samedi", date: null, appointments: [] },
      ],
      loading: false,
    };
  },

  watch: {
    date: async function () {
      await this.calculeDates();
    },
    distancial: async function () {
      await this.calculeDates();
    },
  },

  async mounted() {
    await this.calculeDates();
  },

  methods: {
    async calculeDates() {
      this.days.forEach((day) => {
        day.appointments = false;
      });
      await Promise.all(
        this.days.map(async (day) => {
          let date = moment(this.date);
          day.date = date
            .isoWeekday(day.isoWeekday)
            .locale("fr")
            .format("Do MMM YYYY");

            if(date.isAfter()) {
              day.appointments = await this.getDayAppointment(day.isoWeekday);
            } else {
              day.appointments = [];
            }
        })
      );
    },
    async getDayAppointment(isoWeekday) {
      var date = moment(this.date).isoWeekday(isoWeekday);

      var appointments = await getAllActivitesByActionAndLocationAsync(
        this.action,
        this.distancial ? null : this.office.id,
        date.format("YYYY-MM-DD"),
        date.format("YYYY-MM-DD"),
        this.$root.slug
      );

      var result = [];
      appointments.forEach((appointment) => {
        let startAt = moment(appointment.startAt);

        if (
          (this.distancial || !appointment.isDistancial) &&
          startAt.isAfter() &&
          appointment.consultant
        ) {
          result.push({
            id: appointment.id,
            start: startAt,
            end: moment(startAt).add(appointment.duration, "minute"),
            consultant: appointment.consultant.email,
            consultantId: appointment.consultant.id,
          });
        }
      });

      result.sort((a, b) => a.start.diff(b.start));

      let previous = null;
      result = result.filter((e) => {
        if (
          previous &&
          e.start.isSame(previous.start) &&
          e.end.isSame(previous.end)
        ) {
          previous = e;
          return false;
        }
        previous = e;
        return true;
      });

      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.slot {
  padding: 0.5rem;
  font-weight: 500;
  font-size: 0.95em;
  cursor: pointer;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.no-items {
  cursor: initial;
  font-weight: 500;
  font-size: 0.9em;
}

.b-skeleton {
  height: 2.5rem;
}
</style>